// Shared AVBD contact/friction tuning used by warmstart, primal, and dual stages.
export const AVBD_FRICTION_STATIC = 0.75;
// Keep dynamic equal to static for now. This matches the simpler 2D reference
// behavior and avoids static/dynamic regime switching drift ("motoring").
export const AVBD_FRICTION_DYNAMIC = 0.75;
// Matches the public AVBD 3D reference. The margin is part of the cached
// contact constraint C0 and prevents resting contacts from flickering.
export const AVBD_COLLISION_MARGIN = 0.01;
